import callApi from './callApi';
import { config } from './config';

const sendDatadogEvent = (
  event: 'checkout-load' | 'checkout-error' | 'checkout-redirect',
  error?: Error,
  customMessage?: any
) => {
  const startTimer = window.ayCheckout?.startTimer ?? 0;
  const loadTime = Date.now() - startTimer;

  return callApi({
    endpoint: '/debug/logs',
    method: 'POST',
    flow: 'legacy',
    payload: {
      env: config.environment,
      severity: event === 'checkout-error' ? 'error' : 'info',
      origin: config.origin,
      event,
      service: 'checkout-frontend',
      appId: Number(config.appId),
      message: error?.message ?? JSON.stringify(customMessage) ?? 'checkout-load',
      ...(event === 'checkout-load' && startTimer && { loadTime })
    }
  });
};

export default sendDatadogEvent;
